const variables = {
    widgetUrl: 'https://widget.passwort-generator.com/webmaster/',
    poweredByUrl: 'https://www.passwort-generator.com/webmaster',
}

export default variables



// WEBPACK FOOTER //
// ./src/config/variables.js